module.exports = __webpack_public_path__ + "img/validated-sobrevivencia.29912d6e.svg";